var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBadgeDiamond(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.894 5.107h10.212l4.851 8.68-4.85 8.682H6.893l-4.851-8.681 4.85-8.68z",
    fill: "#F9325A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 13.788l4.823-8.63h10.154l4.823 8.63-4.823 8.63H6.923L2.1 13.789z",
    stroke: "#fff",
    strokeOpacity: 0.45,
    strokeWidth: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0l5.107 5.106H6.894L12.001 0z",
    fill: "#FA6684"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.15l6.894-2.043-4.851 8.681L0 7.15z",
    fill: "#FA6684"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.574l5.107-5.106H6.894l5.107 5.106z",
    fill: "#FA6684"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.425l-6.894 2.042 4.851-8.68L24 20.424z",
    fill: "#FA6684"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L6.894 5.106 0 7.15 12 0z",
    fill: "#F9325A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.574l-5.106-5.106L0 20.425l12 7.15z",
    fill: "#F9325A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.148l2.043 6.639L0 20.425V7.148z",
    fill: "#F9325A"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0l5.106 5.106L24 7.15 12 0z",
    fill: "#F9325A"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.574l5.106-5.106L24 20.425l-12 7.15z",
    fill: "#F9325A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.148l-2.043 6.639L24 20.425V7.148z",
    fill: "#F9325A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M19.976 10.02l2.01 3.48-15.352 8.862-2.009-3.48z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M18.29 7.2l.504.873-15.89 9.174-.503-.873z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.425l6.894 2.042-4.851-8.68L0 20.424z",
    fill: "#FA6684"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.15l-6.894-2.043 4.851 8.681L24 7.15z",
    fill: "#FA6684"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 18.552h7.2V20.4H8.4v-1.848zm3.557-8.448a3.653 3.653 0 011.809.44c.527.294.79.847.79 1.661v3.1c0 .214.004.475.012.78-.005.164.029.327.096.471a.59.59 0 00.24.205v.26H13.14a2.098 2.098 0 01-.102-.384 4.694 4.694 0 01-.046-.41 3.397 3.397 0 01-.773.675c-.363.223-.77.337-1.183.33a1.93 1.93 0 01-1.39-.524c-.375-.372-.578-.92-.55-1.485-.041-.745.303-1.45.882-1.804.447-.242.93-.39 1.423-.434l.551-.074c.22-.02.435-.073.643-.155.2-.062.342-.266.347-.502a.614.614 0 00-.264-.573 1.533 1.533 0 00-.777-.158.961.961 0 00-.813.31c-.123.18-.202.393-.227.62H9.296a2.75 2.75 0 01.455-1.458c.428-.594 1.164-.891 2.206-.891zm.978 3.632a1.71 1.71 0 01-.31.17c-.14.054-.283.095-.429.122l-.364.074a2.208 2.208 0 00-.734.242c-.243.146-.389.438-.375.75-.02.247.066.49.232.653a.82.82 0 00.56.201c.343.002.68-.115.964-.334.294-.224.446-.63.458-1.221l-.002-.657zM15.6 7.2v1.848H8.4V7.2h7.2z",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M6.894 5.107h10.212l4.851 8.68-4.85 8.682H6.893l-4.851-8.681 4.85-8.68z",
    fill: "#F80032"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1 13.788l4.823-8.63h10.154l4.823 8.63-4.823 8.63H6.923L2.1 13.789z",
    stroke: "#fff",
    strokeOpacity: 0.45,
    strokeWidth: 0.1
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0l5.107 5.106H6.894L12.001 0z",
    fill: "#C60028"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.15l6.894-2.043-4.851 8.681L0 7.15z",
    fill: "#C60028"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.574l5.107-5.106H6.894l5.107 5.106z",
    fill: "#C60028"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20.425l-6.894 2.042 4.851-8.68L24 20.424z",
    fill: "#C60028"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0L6.894 5.106 0 7.15 12 0z",
    fill: "#A2122F"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.574l-5.106-5.106L0 20.425l12 7.15z",
    fill: "#A2122F"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.148l2.043 6.639L0 20.425V7.148z",
    fill: "#A2122F"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12 0l5.106 5.106L24 7.15 12 0z",
    fill: "#A2122F"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M12 27.574l5.106-5.106L24 20.425l-12 7.15z",
    fill: "#A2122F"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.148l-2.043 6.639L24 20.425V7.148z",
    fill: "#A2122F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M19.976 10.02l2.01 3.48-15.352 8.862-2.009-3.48z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M18.29 7.2l.504.873-15.89 9.174-.503-.873z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 20.425l6.894 2.042-4.851-8.68L0 20.424z",
    fill: "#C60028"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.15l-6.894-2.043 4.851 8.681L24 7.15z",
    fill: "#C60028"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.4 18.552h7.2V20.4H8.4v-1.848zm3.557-8.448a3.653 3.653 0 011.809.44c.527.294.79.847.79 1.661v3.1c0 .214.004.475.012.78-.005.164.029.327.096.471a.59.59 0 00.24.205v.26H13.14a2.098 2.098 0 01-.102-.384 4.694 4.694 0 01-.046-.41 3.397 3.397 0 01-.773.675c-.363.223-.77.337-1.183.33a1.93 1.93 0 01-1.39-.524c-.375-.372-.578-.92-.55-1.485-.041-.745.303-1.45.882-1.804.447-.242.93-.39 1.423-.434l.551-.074c.22-.02.435-.073.643-.155.2-.062.342-.266.347-.502a.614.614 0 00-.264-.573 1.533 1.533 0 00-.777-.158.961.961 0 00-.813.31c-.123.18-.202.393-.227.62H9.296a2.75 2.75 0 01.455-1.458c.428-.594 1.164-.891 2.206-.891zm.978 3.632a1.71 1.71 0 01-.31.17c-.14.054-.283.095-.429.122l-.364.074a2.208 2.208 0 00-.734.242c-.243.146-.389.438-.375.75-.02.247.066.49.232.653a.82.82 0 00.56.201c.343.002.68-.115.964-.334.294-.224.446-.63.458-1.221l-.002-.657zM15.6 7.2v1.848H8.4V7.2h7.2z",
    fill: "#fff"
  })));
}

export default SvgBadgeDiamond;